import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full min-h-screen bg-[#0b1120] text-gray-300 py-16 px-4 md:px-12 flex flex-col items-center">
            <div className="max-w-[800px] w-full">
                <Link
                    to="/"
                    className="inline-flex items-center text-[#64ffda] hover:underline mb-8 font-medium transition-colors"
                >
                    <HiArrowLeft className="mr-2" /> Back to Home
                </Link>

                <h1 className="text-4xl sm:text-5xl font-bold text-gray-100 border-b-4 border-[#15434e] pb-4 mb-8">
                    Privacy Policy
                </h1>

                <p className="text-sm text-gray-400 mb-6">Last Updated: September 2026</p>

                <section className="space-y-6 text-gray-300 leading-relaxed">
                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">1. Overview</h2>
                        <p>
                            Thank you for visiting my personal developer portfolio (https://sharvansamala.com). Your privacy is important to me. This Privacy Policy explains how information is collected, used, and protected when you visit this website or use the contact form.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">2. Information Collected</h2>
                        <p className="mb-2">
                            This website only collects personal data that you voluntarily provide through the Contact form:
                        </p>
                        <ul className="list-disc list-inside space-y-1 pl-4 text-gray-400">
                            <li>Your Name</li>
                            <li>Your Email Address</li>
                            <li>Message Content and Inquiries</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">3. How Information is Used</h2>
                        <p>
                            Information submitted through the contact form is used solely for corresponding with you, discussing potential professional collaborations, or answering inquiries. Your information is never sold, rented, or shared with third parties for marketing purposes.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">4. Cookies & Analytics</h2>
                        <p>
                            This site may use functional cookies or lightweight anonymized analytics to measure site traffic and optimize performance. You can manage your preferences at any time using the cookie banner or your browser settings.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">5. Third-Party Services</h2>
                        <p>
                            This website may use secure third-party form processing services (such as GetForm.io) to deliver contact messages. External links (such as to GitHub, LinkedIn, or external demo apps) are governed by their respective privacy policies.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-gray-100 mb-2">6. Contact</h2>
                        <p>
                            If you have questions about this Privacy Policy, please reach out via email at{' '}
                            <a href="mailto:samalasharvan@gmail.com" className="text-[#64ffda] hover:underline">
                                samalasharvan@gmail.com
                            </a>.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
